import { render, staticRenderFns } from "./CompanyPreviewDetailSp.vue?vue&type=template&id=1651319e&scoped=true"
import script from "./CompanyPreviewDetailSp.vue?vue&type=script&lang=js"
export * from "./CompanyPreviewDetailSp.vue?vue&type=script&lang=js"
import style0 from "./CompanyPreviewDetailSp.vue?vue&type=style&index=0&id=1651319e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1651319e",
  null
  
)

export default component.exports